import ProductInfo from "./ProductInfo";

export default ProductInfo;



// WEBPACK FOOTER //
// ./src/apps/payment/components/ProductInfo/index.js